export default __webpack_public_path__ + "c618a28da3eb2c3c49b7afc9dbb9e74c.png";